import { useState } from 'react';
import { faqs, guidelines } from '@/mocks/home';
import Reveal from '@/components/feature/Reveal';

export default function TrustFaq() {
  const [openId, setOpenId] = useState<string>(faqs[0]?.id ?? '');

  return (
    <section id="faq" className="w-full border-y border-background-200 bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-5">
            <Reveal>
              <span className="text-xs font-medium tracking-widest text-secondary-800">TRUST / 社区准则</span>
              <h3 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                先把规则讲清楚，再一起安心吃瓜
              </h3>
              <p className="mt-2 text-sm text-foreground-600">
                热闹归热闹，边界要清楚。下面几条是黑料社网社区一直坚持的做法。
              </p>
            </Reveal>

            <div className="mt-6 flex flex-col gap-3">
              {guidelines.map((item, index) => (
                <Reveal key={item.id} delay={index * 60}>
                  <div className="flex gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                      <i className={`${item.icon} text-base`} />
                    </span>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">{item.title}</p>
                      <p className="mt-1 text-xs leading-relaxed text-foreground-600">{item.desc}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={80}>
              <div className="rounded-lg border border-background-200 bg-background-50">
                <div className="flex items-center gap-2 border-b border-background-200 px-5 py-4">
                  <span className="flex h-5 w-5 items-center justify-center text-primary-600">
                    <i className="ri-question-answer-line text-base" />
                  </span>
                  <h4 className="font-heading text-base font-bold text-foreground-950">常见问题</h4>
                </div>
                <div>
                  {faqs.map((faq) => {
                    const isOpen = openId === faq.id;
                    return (
                      <div key={faq.id} className="border-b border-background-100 last:border-b-0">
                        <button
                          type="button"
                          onClick={() => setOpenId(isOpen ? '' : faq.id)}
                          className="flex w-full cursor-pointer items-center gap-3 px-5 py-4 text-left"
                        >
                          <span
                            className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs ${
                              isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-700'
                            }`}
                          >
                            {String(faqs.indexOf(faq) + 1).padStart(2, '0')}
                          </span>
                          <span className="flex-1 text-sm font-medium text-foreground-900">{faq.q}</span>
                          <span className="flex h-4 w-4 shrink-0 items-center justify-center text-foreground-500">
                            <i className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} text-base`} />
                          </span>
                        </button>
                        {isOpen && (
                          <p className="px-5 pb-4 pl-14 text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}